import {Component, EventEmitter, Input, Output} from '@angular/core';
import {GeneralService} from '../../services/general.service';


@Component({
    selector: 'ac-line-separator',
    templateUrl: './ac-line-separator.component.html',
    styleUrls: ['./ac-line-separator.component.less'],
})

export class AcLineSeparatorComponent {
    @Input() title = '';
    @Input() separatorId = '';
    @Input() collapsed: boolean;
    @Input() isCollapsible: boolean;
    @Output() collapsedChange = new EventEmitter();
    constructor(private  generalService: GeneralService) {
    }

    ngOnInit() {
    }

    toggleCollapsed() {
        this.collapsed = !this.collapsed;
        this.collapsedChange.emit(this.collapsed);
        GeneralService.dispatchResizeEvent();
    }

}



